module.exports = __webpack_public_path__ + "static/media/squarePanel2.ed084abb.svg";